(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdp2-main-product"] && !Shopify.designMode) return;
  try {
    
/* Delivery timer: strips the truck emoji (an SVG icon replaces it) and
   reveals the app blocks only once the app has filled them, so half
   loaded states never flash. Scoped to the new PDP via .pdp-buybox. */
(function () {
  function tick() {
    if (!document.querySelector('.pdp-buybox')) return;
    var w = document.getElementById('delivery_timer_wrapper1');
    if (w) {
      var it = document.createNodeIterator(w, NodeFilter.SHOW_TEXT);
      var n;
      while ((n = it.nextNode())) {
        if (n.nodeValue && n.nodeValue.indexOf('\uD83D\uDE9A') !== -1) {
          n.nodeValue = n.nodeValue.replace(/\uD83D\uDE9A\s*/g, '');
        }
      }
    }
    ['delivery_timer_wrapper1', 'visual_timer_wrapper1'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      var blk = el.closest('.shopify-block');
      if (blk && el.textContent.trim().length > 0) blk.classList.add('dlt-ready');
    });
  }
  var mo = new MutationObserver(tick);
  function arm() {
    tick();
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
})();

/* Gallery controls.
   Delegated on document so it does not matter whether main.js has defined
   <product-media> yet. Inline section scripts run before deferred bundles,
   which is the usual way this breaks in Shopify.

   Main arrows reuse the theme's own hidden click zones rather than
   reimplementing slide maths, so behaviour stays identical.
   Rail arrows are ours: the theme scrolls the rail vertically on desktop,
   which no longer matches this horizontal rail. */
document.addEventListener('click', function (e) {
  var t = e.target;
  if (!t || !t.closest) return;

  var mainPrev = t.closest('[data-main-prev]');
  var mainNext = t.closest('[data-main-next]');
  if (mainPrev || mainNext) {
    var media = (mainPrev || mainNext).closest('product-media');
    if (!media) return;
    var zone = media.querySelector(mainPrev ? '[data-main-left]' : '[data-main-right]');
    if (zone) zone.click();
    return;
  }

  var railPrev = t.closest('[data-rail-prev]');
  var railNext = t.closest('[data-rail-next]');
  if (railPrev || railNext) {
    var wrap = (railPrev || railNext).closest('product-media');
    if (!wrap) return;
    var rail = wrap.querySelector('[data-thumbnail-slider]');
    var thumb = wrap.querySelector('[data-thumbnail]');
    if (!rail || !thumb) return;
    var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 12;
    var step = thumb.getBoundingClientRect().width + gap;
    rail.scrollBy({ left: railPrev ? -step : step, behavior: 'smooth' });
    return;
  }

  /* testimonial carousel. Its own hooks so the theme's product-media
     component never binds them. */
  var reviewPrev = t.closest('[data-review-prev]');
  var reviewNext = t.closest('[data-review-next]');
  if (reviewPrev || reviewNext) {
    var group = (reviewPrev || reviewNext).closest('.pdp-reviews');
    if (!group) return;
    var track = group.querySelector('[data-review-track]');
    var card = track && track.firstElementChild;
    if (!card) return;
    var trackStyle = getComputedStyle(track);
    var cardGap = parseFloat(trackStyle.columnGap || trackStyle.gap) || 0;
    var cardStep = card.getBoundingClientRect().width + cardGap;
    track.scrollBy({ left: reviewPrev ? -cardStep : cardStep, behavior: 'smooth' });
    return;
  }

  /* add-ons carousel. Same scroll-by-one-card approach as the testimonial
     carousel above, targeting the buybox's own track instead. */
  var addonsPrev = t.closest('[data-addons-prev]');
  var addonsNext = t.closest('[data-addons-next]');
  if (addonsPrev || addonsNext) {
    var addonsGroup = (addonsPrev || addonsNext).closest('.pdp-buybox__addons');
    if (!addonsGroup) return;
    var addonsTrack = addonsGroup.querySelector('[data-addons-track]');
    /* first VISIBLE card: the track's first child is a mobile wrap clone
       that is display:none on desktop, so its width is 0 and the step
       collapsed to the gap - which snap-proximity then undid entirely. */
    var addonsCard = null;
    if (addonsTrack) {
      for (var ai = 0; ai < addonsTrack.children.length; ai++) {
        if (addonsTrack.children[ai].offsetWidth > 0) { addonsCard = addonsTrack.children[ai]; break; }
      }
    }
    if (!addonsCard) return;
    var addonsTrackStyle = getComputedStyle(addonsTrack);
    var addonsGap = parseFloat(addonsTrackStyle.columnGap || addonsTrackStyle.gap) || 0;
    var addonsStep = addonsCard.getBoundingClientRect().width + addonsGap;
    addonsTrack.scrollBy({ left: addonsPrev ? -addonsStep : addonsStep, behavior: 'smooth' });
  }
});

/* Add to cart button price. assets/main.js recomputes [data-atc-btn-price]
   on add-on checkbox change (product-form's updateTotalPrice), but never on
   a plain size change, and it formats as "1,699.00 USD" while the main
   price uses the store's money format ($1,699.00).

   Reading .pdp-buybox__price back out was the first attempt here, but that
   node updates asynchronously (product-details fetches the section over the
   network on variant:change and swaps it in), and this listener fires
   synchronously in the same tick as the dispatch, so it read the price that
   was about to be replaced. Reading variant.price straight off the
   variant:change event detail, or off the product JSON already embedded in
   the page for every other case, needs no network round trip and can't race
   it. Everything below is integer cents until the final render, so this
   also sidesteps float drift from repeated dollar addition.

   Runs after main.js's own listener on the same events (target-phase
   listeners fire before this document-level one), so it always has the
   last word. US-only store, USD only, hence the hardcoded $ and en-US. */
function pdpBasePriceCents() {
  var variantId = document.querySelector('[data-variant-id]')?.value;
  var dataEl = document.querySelector('script[data-product-data]');
  if (!variantId || !dataEl) return null;
  try {
    var product = JSON.parse(dataEl.textContent);
    var variant = (product.variants || []).find(function (v) { return String(v.id) === String(variantId); });
    return variant ? variant.price : null;
  } catch (e) {
    return null;
  }
}
function updatePdpAtcPrice(basePriceCents) {
  var priceEl = document.querySelector('[data-atc-btn-price]');
  if (!priceEl) return;
  if (basePriceCents == null) basePriceCents = pdpBasePriceCents();
  if (basePriceCents == null) return;
  var totalCents = basePriceCents;
  document.querySelectorAll('input[data-enclosure-product]:checked, input[data-assembly-product]:checked').forEach(function (input) {
    totalCents += parseInt(input.dataset.price, 10) || 0;
  });
  priceEl.textContent = '$' + (totalCents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
document.addEventListener('variant:change', function (e) {
  var variant = e.detail && e.detail.variant;
  updatePdpAtcPrice(variant ? variant.price : null);
});
document.addEventListener('change', function (e) {
  if (e.target.matches('input[data-enclosure-product], input[data-assembly-product]')) updatePdpAtcPrice();
});
/* product-form's own connectedCallback calls its updateTotalPrice() once on
   upgrade, in the "amount USD" format, which stomps the money-filtered value
   Liquid rendered. whenDefined's .then() is a microtask, queued after that
   synchronous upgrade (and its connectedCallback) finishes, so this runs
   after main.js's init call and gets the last, correctly-formatted word. */
customElements.whenDefined('product-form').then(function () { updatePdpAtcPrice(); });

/* One accordion row open at a time.

   The theme's accordion-component toggles is-active on itself and knows
   nothing about its siblings, so several rows can sit open at once. Figma
   58687:3567 draws exactly one open.

   Closing the others by stripping the class would desync the component:
   it would still believe it is open and the next click would do nothing.
   So the sibling's own button is clicked instead, which runs the component's
   real toggle. The syncing flag stops that synthetic click re-entering here.

   Delegated on document because inline section scripts run before the
   deferred bundle upgrades the element. Scoped to .pdp-accordion-list so it
   cannot reach the unrelated accordions in sections/faq.liquid. */
var pdpAccordionSyncing = false;
document.addEventListener('click', function (e) {
  if (pdpAccordionSyncing) return;
  var t = e.target;
  if (!t || !t.closest) return;
  var row = t.closest('.pdp-accordion-row');
  if (!row) return;
  var list = row.closest('.pdp-accordion-list');
  if (!list) return;

  setTimeout(function () {
    if (!row.classList.contains('is-active')) return;
    var open = list.querySelectorAll('.pdp-accordion-row.is-active');
    pdpAccordionSyncing = true;
    for (var i = 0; i < open.length; i++) {
      if (open[i] === row) continue;
      var btn = open[i].querySelector('button');
      if (btn) btn.click();
    }
    pdpAccordionSyncing = false;
  }, 0);
});

/* Complete Your Setup. sections/complete-setup.liquid is a static section
   nested inside product-details for layout, rendered there through
   snippets/product.complete-setup.liquid's {% section %} call. That inline
   render always sees recommendations.performed? == false (the object is
   only populated when a section is rendered through the Product
   Recommendations API), so [data-complete-setup] loads empty. This fetches
   the same section again through that API, which does populate
   recommendations, and swaps the populated markup in. Same
   data-url-plus-DOMParser shape as the theme's own <product-recommendations>
   element in main.js, just with the two-intent fallback that generic
   component has no way to do.

   intent=complementary is what a merchant configures in the Search and
   Discovery app and is tried first. When that comes back with no cards,
   intent=related, Shopify's automatic recommendation with no setup
   required, is tried next, unless the section's allow_related_fallback
   setting has turned that off. If nothing ever comes back the placeholder
   is removed outright rather than left behind as an empty heading-less
   shell. */
(function () {
  var wrap = document.querySelector('[data-complete-setup]');
  if (!wrap || !wrap.dataset.url) return;
  var allowFallback = wrap.dataset.allowFallback === 'true';

  function fetchIntent(intent, isLastAttempt) {
    fetch(wrap.dataset.url + '&intent=' + intent)
      .then(function (response) {
        if (!response.ok) throw new Error(response.statusText);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fetched = doc.querySelector('[data-complete-setup]');
        var cards = fetched ? fetched.querySelectorAll('[data-complete-setup-card]') : [];
        if (cards.length > 0) {
          wrap.innerHTML = fetched.innerHTML;
        } else if (isLastAttempt) {
          wrap.remove();
        } else {
          fetchIntent('related', true);
        }
      })
      .catch(function (error) {
        if (isLastAttempt) {
          wrap.remove();
        } else {
          fetchIntent('related', true);
        }
        console.error('Failed to fetch complete your setup recommendations:', error);
      });
  }

  var completeSetupObserver = new IntersectionObserver(
    function (entries, obs) {
      if (!entries[0].isIntersecting) return;
      obs.disconnect();
      fetchIntent('complementary', !allowFallback);
    },
    { rootMargin: '0px 0px 200px 0px' }
  );
  completeSetupObserver.observe(wrap);
})();

/* Enhanced variant select, see the CSS block for the contract. Reads the
   native select's options on every open so availability and selection can
   never drift from the theme's own state. */
(function () {
  function enhance(sel) {
    if (sel.dataset.enhanced) return;
    sel.dataset.enhanced = '1';
    var control = sel.closest('.pdp-buybox__size-control');
    if (!control || !control.parentElement) return;
    var wrap = document.createElement('div');
    wrap.className = 'pdp-select is-ready';
    control.parentElement.insertBefore(wrap, control);
    wrap.appendChild(control);

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'pdp-buybox__size-control pdp-select__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.innerHTML = "<span class='pdp-select__value'></span>" +
      "<svg class='pdp-select__chev' width='16' height='16' viewBox='0 0 16 16' fill='none' aria-hidden='true'>" +
      "<path d='M4 6l4 4 4-4' stroke='#131313' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/></svg>";
    wrap.appendChild(trigger);

    var panel = document.createElement('div');
    panel.className = 'pdp-select__panel';
    panel.setAttribute('role', 'listbox');
    wrap.appendChild(panel);

    function label() {
      var o = sel.options[sel.selectedIndex];
      trigger.querySelector('.pdp-select__value').textContent = o ? o.text : '';
    }
    function rebuild() {
      panel.innerHTML = '';
      Array.prototype.forEach.call(sel.options, function (o, i) {
        var row = document.createElement('div');
        row.className = 'pdp-select__option';
        row.setAttribute('role', 'option');
        row.dataset.index = i;
        row.textContent = o.text;
        if (i === sel.selectedIndex) row.setAttribute('aria-selected', 'true');
        if (o.disabled) row.setAttribute('aria-disabled', 'true');
        panel.appendChild(row);
      });
    }
    function open() {
      rebuild();
      wrap.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      var cur = panel.querySelector("[aria-selected='true']");
      if (cur) cur.scrollIntoView({ block: 'nearest' });
    }
    function close() {
      wrap.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }
    function pick(row) {
      if (!row || row.getAttribute('aria-disabled') === 'true') return;
      sel.selectedIndex = Number(row.dataset.index);
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      label();
      close();
      trigger.focus();
    }

    trigger.addEventListener('click', function () {
      wrap.classList.contains('is-open') ? close() : open();
    });
    panel.addEventListener('click', function (e) {
      pick(e.target.closest('.pdp-select__option'));
    });
    sel.addEventListener('change', label);

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault(); open();
      }
      if (e.key === 'Escape') close();
    });
    wrap.addEventListener('keydown', function (e) {
      if (!wrap.classList.contains('is-open')) return;
      var rows = Array.prototype.filter.call(
        panel.querySelectorAll('.pdp-select__option'),
        function (r) { return r.getAttribute('aria-disabled') !== 'true'; });
      var active = panel.querySelector('.is-active') || panel.querySelector("[aria-selected='true']");
      var idx = rows.indexOf(active);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        idx = e.key === 'ArrowDown' ? Math.min(rows.length - 1, idx + 1) : Math.max(0, idx - 1);
        rows.forEach(function (r) { r.classList.remove('is-active'); });
        if (rows[idx]) { rows[idx].classList.add('is-active'); rows[idx].scrollIntoView({ block: 'nearest' }); }
      }
      if (e.key === 'Enter') { e.preventDefault(); pick(panel.querySelector('.is-active') || active); }
      if (e.key === 'Escape') { close(); trigger.focus(); }
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) close();
    });
    label();
  }
  document.querySelectorAll('.pdp-buybox__size-select').forEach(enhance);
})();

/* Gallery lightbox. Desktop clicks land on the theme's own left/right
   overlay zones, so those are intercepted in the CAPTURE phase and
   repurposed to open the lightbox at the current slide; the round
   arrows keep doing the in-gallery navigation. On mobile the zones are
   hidden and the tap lands on the track directly. */
(function () {
  var lb = null, lbItems = [], lbIndex = 0;

  function hi(src) {
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$1' + 2048) : src;
  }
  function collect() {
    var slides = document.querySelectorAll('.pdp-media__track .pdp-media__slide, .pdp-media__track [data-main-image]');
    var items = [];
    slides.forEach(function (sl) {
      var img = sl.tagName === 'IMG' ? sl : sl.querySelector('img');
      if (img && img.currentSrc) items.push({ full: hi(img.currentSrc), thumb: img.currentSrc, alt: img.alt || '' });
    });
    return items;
  }
  function activeIndex() {
    var thumbs = document.querySelectorAll('[data-thumbnail]');
    for (var i = 0; i < thumbs.length; i++) if (thumbs[i].classList.contains('is-active')) return i;
    return 0;
  }
  function build() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'pdp-lightbox';
    lb.innerHTML =
      "<div class='pdp-lightbox__top'>" +
        "<span class='pdp-lightbox__count' data-lb-count></span>" +
        "<div class='pdp-lightbox__actions'>" +
          "<button type='button' class='pdp-lightbox__btn' data-lb-zoom aria-label='Zoom'>" +
            "<svg viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1.6' stroke-linecap='round'><circle cx='7' cy='7' r='5'/><path d='M14.5 14.5 10.6 10.6M7 4.8v4.4M4.8 7h4.4'/></svg></button>" +
          "<button type='button' class='pdp-lightbox__btn' data-lb-close aria-label='{{ 'accessibility.close_modal' | t }}'>" +
            "<svg viewBox='0 0 14 14' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round'><path d='M1 1l12 12M13 1L1 13'/></svg></button>" +
        "</div></div>" +
      "<div class='pdp-lightbox__stage' data-lb-stage></div>" +
      "<button type='button' class='pdp-lightbox__nav pdp-lightbox__nav--prev' data-lb-prev aria-label='{{ 'accessibility.previous_image' | t }}'>" +
        "<svg viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M10 3 5 8l5 5'/></svg></button>" +
      "<button type='button' class='pdp-lightbox__nav pdp-lightbox__nav--next' data-lb-next aria-label='{{ 'accessibility.next_image' | t }}'>" +
        "<svg viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='m6 3 5 5-5 5'/></svg></button>" +
      "<div class='pdp-lightbox__thumbs' data-lb-thumbs></div>";
    document.body.appendChild(lb);
    lb.style.display = 'none';
    return lb;
  }
  function renderLb() {
    var item = lbItems[lbIndex];
    if (!item) return;
    lb.classList.remove('is-zoomed');
    lb.querySelector('[data-lb-stage]').innerHTML =
      "<img class='pdp-lightbox__media' src='" + item.full + "' alt=''>";
    lb.querySelector('.pdp-lightbox__media').alt = item.alt;
    lb.querySelector('[data-lb-count]').textContent = (lbIndex + 1) + ' / ' + lbItems.length;
    var wrap = lb.querySelector('[data-lb-thumbs]');
    wrap.innerHTML = '';
    lbItems.forEach(function (it, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pdp-lightbox__thumb' + (i === lbIndex ? ' is-current' : '');
      b.dataset.lbIndex = i;
      b.innerHTML = "<img src='" + it.thumb + "' alt=''>";
      wrap.appendChild(b);
    });
    var cur = wrap.querySelector('.is-current');
    if (cur) cur.scrollIntoView({ block: 'nearest', inline: 'center' });
  }
  function openLb(i) {
    lbItems = collect();
    if (!lbItems.length || !build()) return;
    lbIndex = Math.max(0, Math.min(lbItems.length - 1, i));
    lb.style.display = '';
    document.body.classList.add('pdp-lightbox-open');
    renderLb();
  }
  function closeLb() {
    if (!lb) return;
    lb.style.display = 'none';
    document.body.classList.remove('pdp-lightbox-open');
  }
  function lbGo(i) { lbIndex = (i + lbItems.length) % lbItems.length; renderLb(); }

  document.addEventListener('click', function (e) {
    var zone = e.target.closest && e.target.closest('[data-main-left], [data-main-right]');
    if (zone && zone.closest('product-media')) {
      e.stopPropagation();
      e.preventDefault();
      openLb(activeIndex());
    }
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!e.target.closest('[data-main-left], [data-main-right], .pdp-media__arrow')
      && t.closest('.pdp-media__track')) { openLb(activeIndex()); return; }
    if (!lb || lb.style.display === 'none') return;
    if (t.closest('[data-lb-close]')) { closeLb(); return; }
    if (t.closest('[data-lb-prev]')) { lbGo(lbIndex - 1); return; }
    if (t.closest('[data-lb-next]')) { lbGo(lbIndex + 1); return; }
    if (t.closest('[data-lb-zoom]') || t.closest('.pdp-lightbox__media')) {
      lb.classList.toggle('is-zoomed'); return;
    }
    var th = t.closest('.pdp-lightbox__thumb');
    if (th) { lbGo(Number(th.dataset.lbIndex)); return; }
    if (t.classList.contains('pdp-lightbox__stage') || t.classList.contains('pdp-lightbox__top')) closeLb();
  });

  document.addEventListener('keydown', function (e) {
    if (!lb || lb.style.display === 'none') return;
    if (e.key === 'Escape') closeLb();
    if (e.key === 'ArrowRight') lbGo(lbIndex + 1);
    if (e.key === 'ArrowLeft') lbGo(lbIndex - 1);
  });

  var lbTouchX = null;
  document.addEventListener('touchstart', function (e) {
    if (lb && lb.style.display !== 'none') lbTouchX = e.touches[0].clientX;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (lbTouchX === null || !lb || lb.style.display === 'none') return;
    var dx = e.changedTouches[0].clientX - lbTouchX;
    lbTouchX = null;
    if (dx < -40) lbGo(lbIndex + 1);
    if (dx > 40) lbGo(lbIndex - 1);
  }, { passive: true });
})();

/* Testimonial widget placement. Desktop: under the gallery (its rendered
   spot). Below lg the columns stack and Calvin wants it at the very end,
   under the Complete Your Setup widget, so it appends into .pdp-widgets
   (the right column flex, whose gap spaces it for free) and returns to a
   comment anchor when the viewport grows back. */
(function () {
  var reviews = document.querySelector('.pdp-reviews');
  var target = document.querySelector('.product-details .pdp-widgets') || document.querySelector('.pdp-widgets');
  if (!reviews || !target) return;
  var anchor = document.createComment('pdp-reviews-home');
  reviews.parentNode.insertBefore(anchor, reviews);
  var mq = window.matchMedia('(max-width: 1023px)');
  /* Also wired to resize: emulated viewports (and some browsers on
     orientation flips) skip the matchMedia change event. place() is
     idempotent, so the extra calls are no-ops. */
  function place() {
    if (mq.matches) {
      if (reviews.parentNode !== target) target.appendChild(reviews);
    } else if (anchor.parentNode && reviews.previousSibling !== anchor) {
      anchor.parentNode.insertBefore(reviews, anchor.nextSibling);
    }
  }
  place();
  mq.addEventListener('change', place);
  window.addEventListener('resize', place);
})();

/* Floating ATC pill: shows once the real add-to-cart has scrolled past
   the top of the viewport, hides when it is visible again or when the
   user is above it. The pill button proxies the real submit. */
(function () {
  var bar = document.querySelector('[data-sticky-atc]');
  var main = document.querySelector('.pdp-buybox__submit');
  if (!bar || !main) return;
  /* The pill CTA takes the shopper to the buy box to pick a variant
     first (Calvin's call), rather than blind-submitting the form. The
     pill then hides itself because the real button is back in view. */
  bar.querySelector('[data-sticky-atc-btn]').addEventListener('click', function () {
    var target = document.querySelector('.pdp-buybox') || main;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  /* plain position check on scroll, not IntersectionObserver: an
     instant jump (anchor link, restored scroll) can teleport PAST the
     button without ever intersecting it, and IO fires nothing then. */
  var stickyTicking = false;
  function stickyUpdate() {
    stickyTicking = false;
    var show = main.getBoundingClientRect().bottom < 0;
    bar.classList.toggle('is-visible', show);
    document.body.classList.toggle('gb-pill-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    liftChat(show);
  }
  /* Tawk.to's bubble is an iframe whose position is INLINE with
     !important, so no stylesheet can move it. This sets an inline
     !important bottom of our own, re-applied on every sticky update so
     the widget cannot reset it while the pill is up. Only the small
     bubble is moved, never the opened chat panel. */
  function liftChat(show) {
    /* lift = pill height + its bottom gap + breathing room; transform-safe
       because offsetHeight and computed bottom ignore the reveal animation */
    var lift = 88;
    if (bar) {
      var barBottom = parseFloat(getComputedStyle(bar).bottom) || 12;
      lift = Math.ceil(bar.offsetHeight + barBottom + 8);
    }
    /* Tawk is several fixed boxes: bubble, chat panel, attention-grabber
       sticker and its close button - random ids, and the sticker has
       z-index auto, so no string or z-index test finds them all. Match by
       geometry instead: any visible fixed iframe (or its fixed wrapper)
       parked in the bottom-right corner is chat furniture. */
    var nodes = document.querySelectorAll('iframe, [class*="tawk"], [id*="tawk"]');
    var targets = [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var target = null;
      while (el && el !== document.body) {
        if (getComputedStyle(el).position === 'fixed') { target = el; break; }
        el = el.parentElement;
      }
      if (!target) continue;
      var r = target.getBoundingClientRect();
      if (r.width < 1 || r.height < 1) continue;
      if (r.bottom < window.innerHeight - 480 || r.right < window.innerWidth - 480) continue;
      if (targets.indexOf(target) === -1) targets.push(target);
    }
    /* shift the WHOLE chat cluster (open panel included) by one shared
       delta while the pill is up. Uniform movement keeps Tawk's own
       layout (panel above its minimize bubble) intact in every state,
       and opening/closing the chat no longer flips anything, so nothing
       jumps around. */
    for (var j = 0; j < targets.length; j++) {
      var t = targets[j];
      /* the attention-grabber renders inside a big transparent canvas
         that stretches almost edge to edge, so no left-edge test - only
         skip true full-viewport overlays (e.g. preview scaffolding) */
      var tr = t.getBoundingClientRect();
      if (tr.width >= window.innerWidth * 0.95 && tr.height >= window.innerHeight * 0.95) continue;
      /* translateY instead of rewriting `bottom`: a pure relative shift
         needs no snapshot of the natural position, so it stays correct
         when Tawk itself repositions pieces. */
      if (show) {
        if (!t.dataset.gbLifted) {
          t.dataset.gbTfSaved = t.style.getPropertyValue('transform') || '__none__';
          t.style.setProperty('transition', 'transform 0.25s ease', 'important');
          t.dataset.gbLifted = '1';
        }
        var want = 'translateY(-' + lift + 'px)';
        if (t.style.getPropertyValue('transform') !== want) {
          t.style.setProperty('transform', want, 'important');
        }
      } else if (t.dataset.gbLifted) {
        if (t.dataset.gbTfSaved === '__none__') t.style.removeProperty('transform');
        else t.style.setProperty('transform', t.dataset.gbTfSaved, 'important');
        t.dataset.gbLifted = '';
      }
    }
  }
  window.addEventListener('scroll', function () {
    if (!stickyTicking) { stickyTicking = true; requestAnimationFrame(stickyUpdate); }
  }, { passive: true });
  stickyUpdate();
  /* opening/closing the chat happens inside the widget, without any page
     scroll, so re-check on a timer too - this is what un-shifts the panel
     the moment it opens and re-lifts the bubble when it closes */
  setInterval(function () {
    liftChat(bar.classList.contains('is-visible'));
  }, 800);
  /* Tawk shows the attention-grabber sticker again the moment the chat
     closes; waiting for the next interval tick painted it at its natural
     spot first and it visibly hopped up. Mutation callbacks run before
     the next paint, so re-applying here moves new/changed pieces in the
     same frame - no hop. Writes above are value-checked, so this settles
     instead of re-triggering itself forever. */
  new MutationObserver(function () {
    liftChat(bar.classList.contains('is-visible'));
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
})();

/* Add-ons infinite wrap (mobile). Clones of the last and first card sit at
   the track's edges so a swipe past either end always shows a next card;
   once scrolling settles on a clone, an instant jump lands on its real
   counterpart. Clones are stripped of their checkbox (they would double
   the add-on inside the product form) and proxy clicks to the original,
   mirroring its checked state via .is-checked. */
(function () {
  var track = document.querySelector('.pdp-buybox__addons-track');
  if (!track || track.children.length < 2) return;
  var mq = window.matchMedia('(max-width: 767px)');

  function makeClone(src) {
    var clone = src.cloneNode(true);
    var input = clone.querySelector('input');
    var orig = src.querySelector('input');
    if (input) input.remove();
    clone.setAttribute('data-addon-clone', '');
    clone.setAttribute('aria-hidden', 'true');
    clone.addEventListener('click', function (e) {
      e.preventDefault();
      if (orig) orig.click();
    });
    if (orig) {
      orig.addEventListener('change', function () {
        clone.classList.toggle('is-checked', orig.checked);
      });
      clone.classList.toggle('is-checked', orig.checked);
    }
    return clone;
  }

  var kids = track.children;
  track.insertBefore(makeClone(kids[kids.length - 1]), kids[0]);
  track.appendChild(makeClone(kids[1]));

  function posOf(el) {
    return el.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
  }
  function jumpTo(el) {
    var prev = track.style.scrollBehavior;
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = posOf(el);
    track.style.scrollBehavior = prev;
  }
  function initPos() {
    jumpTo(track.children[1]);
  }

  var settleTimer;
  track.addEventListener('scroll', function () {
    clearTimeout(settleTimer);
    settleTimer = setTimeout(function () {
      var all = track.children;
      var x = track.scrollLeft;
      if (Math.abs(x - posOf(all[all.length - 1])) < 8) {
        jumpTo(all[1]);
      } else if (Math.abs(x - posOf(all[0])) < 8) {
        jumpTo(all[all.length - 2]);
      }
    }, 90);
  }, { passive: true });

  /* pagination dots: one per real card; a park on an edge clone lights
     the card it duplicates (the opposite end). */
  var realCards = [].slice.call(track.children, 1, -1);
  var dotsWrap = document.createElement('div');
  dotsWrap.className = 'pdp-buybox__addons-dots';
  var dots = realCards.map(function (card, i) {
    var d = document.createElement('button');
    d.type = 'button';
    d.className = 'pdp-buybox__addons-dot';
    d.setAttribute('aria-label', 'Go to add-on ' + (i + 1));
    d.addEventListener('click', function () {
      track.scrollTo({ left: posOf(realCards[i]), behavior: 'smooth' });
    });
    dotsWrap.appendChild(d);
    return d;
  });
  /* dots sit beside the title, in the spot the desktop arrows occupy */
  var addonsHead = track.parentNode.querySelector('.pdp-buybox__addons-head');
  (addonsHead || track.parentNode).appendChild(dotsWrap);
  function syncDots() {
    var x = track.scrollLeft;
    var best = 0;
    var bestDist = Infinity;
    realCards.forEach(function (card, i) {
      var dist = Math.abs(x - posOf(card));
      if (dist < bestDist) { bestDist = dist; best = i; }
    });
    var all = track.children;
    if (Math.abs(x - posOf(all[0])) < bestDist) best = realCards.length - 1;
    if (Math.abs(x - posOf(all[all.length - 1])) < bestDist) best = 0;
    dots.forEach(function (d, k) { d.classList.toggle('is-active', k === best); });
  }
  track.addEventListener('scroll', syncDots, { passive: true });
  syncDots();

  initPos();
  mq.addEventListener('change', initPos);
  window.addEventListener('resize', function () {
    clearTimeout(settleTimer);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp2-video-with-text"] && !Shopify.designMode) return;
  try {
    
/* YouTube poster: clicking (or Enter/Space) swaps the poster for the
   autoplaying embed. */
(function () {
  function activate(el) {
    var mobile = window.matchMedia('(max-width: 767px)').matches;
    var src = el.getAttribute('data-embed');
    if (mobile) {
      /* playsinline=0 makes iOS open the native fullscreen player on
         play; Android gets an explicit fullscreen request below, valid
         because we are still inside the user's tap gesture */
      src = src.replace('playsinline=1', 'playsinline=0');
    }
    var iframe = document.createElement('iframe');
    iframe.className = 'video-wide__embed';
    iframe.src = src;
    iframe.title = 'Video';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen');
    iframe.setAttribute('allowfullscreen', '');
    el.replaceWith(iframe);
    if (mobile && iframe.requestFullscreen) {
      try { iframe.requestFullscreen().catch(function () {}); } catch (err) {}
    }
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-yt-poster]');
    if (el) activate(el);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest && e.target.closest('[data-yt-poster]');
    if (el) { e.preventDefault(); activate(el); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
